import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/uptime.list.query.gql"
import type {
  UptimeTargetsListQuery,
  UptimeTargetsListQueryVariables,
} from "@/v2-backoffice-client/uptime/__types__/uptime.list.query"

type Options = QueryHookOptions<
  UptimeTargetsListQuery,
  UptimeTargetsListQueryVariables
>

export function useUptimeTargetsListQuery(options?: Options) {
  return useQuery<UptimeTargetsListQuery, UptimeTargetsListQueryVariables>(
    query,
    options,
  )
}
